import { Action } from '@ngrx/store';
import { OverviewState, SearchFilterSort } from '../overview.state';

export const ActionTypes = {
    ADD_OVERVIEW_CONTENT: '[Overview Container] Add',
    SET_TOTAL_ITEMS: '[Overview Container] Set total items',
    SET_LOADING: '[Overview Container] Set loading'
};

export class AddOverviewContent implements Action {
    type = ActionTypes.ADD_OVERVIEW_CONTENT;
    payload: SearchFilterSort;

    public constructor(state: SearchFilterSort) {
        this.payload = state;
    }
}

export class SetTotal implements Action {
    type = ActionTypes.SET_TOTAL_ITEMS;
    payload: number;

    public constructor(total: number) {
        this.payload = total;
    }
}


export class SetLoading implements Action {
    type = ActionTypes.SET_LOADING;
    payload: boolean;

    public constructor(loading: boolean) {
        this.payload = loading;
    }
}
